import { render, staticRenderFns } from "./TranslatedEntityRenderer.vue?vue&type=template&id=c46c3f6a&"
import script from "./TranslatedEntityRenderer.vue?vue&type=script&lang=js&"
export * from "./TranslatedEntityRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports